import script from "./Book.vue?vue&type=script&setup=true&lang=ts"
export * from "./Book.vue?vue&type=script&setup=true&lang=ts"

import "./Book.vue?vue&type=style&index=0&id=65644dcd&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/bookonline/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65644dcd"]])

export default __exports__